import React from 'react'
import MobileIconAction from './MobileIconAction'
import CLOSE_ICON from '../../../../../public/assets/close-bold.svg'
import RESET_ICON from '../../../../../public/assets/reset-sm.svg'
import BaseButton from '@/components/common/BaseButton'
import type { NarrativeOcgActionsProps } from '../../types'
import { getActionClassName } from '../../utils/classNames'

const getButtonLoader = () => ({
  loaderClassName: 'w-4 justify-center overflow-visible',
  loaderSize: 'small' as const,
})

function NarrativeOcgMobileActions({
  suggestedNarrative,
  canAcceptValidation,
  canDiscard,
  isActionBusy,
  actionLoading,
  onAcceptValidation,
  onDiscardValidation,
  onRevertValidation,
  handleActionClick,
  showDecisionActions = true,
  showSuggestionActions = true,
  showAcceptAction = true,
}: NarrativeOcgActionsProps) {
  return (
    <div className="narrative-ocg-panel__actions narrative-ocg-panel__actions--mobile flex items-center justify-end gap-2">
      <div className="narrative-ocg-panel__icon-actions flex items-center gap-2">
        {showSuggestionActions && onRevertValidation ? (
          <MobileIconAction
            action="revert"
            icon={RESET_ICON}
            label="Revert narrative"
            isActionBusy={isActionBusy}
            actionLoading={actionLoading}
            onClick={event => handleActionClick(event, onRevertValidation)}
          />
        ) : null}
        {showDecisionActions && canDiscard ? (
          <MobileIconAction
            action="discard"
            icon={CLOSE_ICON}
            label="Discard suggestion"
            isActionBusy={isActionBusy}
            actionLoading={actionLoading}
            onClick={event => handleActionClick(event, onDiscardValidation)}
          />
        ) : null}
      </div>
      {showDecisionActions && showAcceptAction ? (
        <BaseButton
          className={getActionClassName('primary', actionLoading === 'accept')}
          disabled={!canAcceptValidation || isActionBusy}
          loading={actionLoading === 'accept'}
          // Accepting re-runs OCG validation: KMK validating animation.
          loader={{ ...getButtonLoader(), variant: 'ocg' }}
          onClick={event =>
            handleActionClick(
              event,
              () =>
                canAcceptValidation &&
                onAcceptValidation?.(suggestedNarrative ?? '')
            )
          }
          type="button"
        >
          Accept
        </BaseButton>
      ) : null}
    </div>
  )
}

export default NarrativeOcgMobileActions
